import * as React from 'react'
import type { SVGProps } from 'react'
function SvgGleichberechtigungVerdienstabstand227212823129(
  props: SVGProps<SVGSVGElement>,
) {
  return (
    <svg
      viewBox="0 0 250.9 257.8"
      x="0px"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      xmlSpace="preserve"
      y="0px"
      {...props}
    >
      <g>
        <path d="M47.8,89.7h12.1v28.4c0,2,1.6,3.6,3.6,3.6s3.6-1.6,3.6-3.6v-32c0-2-1.6-3.6-3.6-3.6h-6.1l38-33l38,33h-6.1 c-2,0-3.6,1.6-3.6,3.6v32c0,2,1.6,3.6,3.5,3.6h0c2,0,3.6-1.6,3.6-3.6V89.7h12.1c1.5,0,2.8-0.9,3.3-2.3c0.5-1.4,0.1-3-1-3.9 L97.6,42.2c-1.3-1.2-3.3-1.2-4.7,0L45.5,83.4c-1.1,1-1.5,2.5-1,3.9C45,88.8,46.3,89.7,47.8,89.7z" />
        <path d="M249.7,42.1L202.2,0.9c-1.3-1.2-3.3-1.2-4.7,0L150,42.1c-1.1,1-1.5,2.5-1,3.9c0.5,1.4,1.9,2.3,3.3,2.3h12.1v69.7 c0,2,1.6,3.6,3.6,3.6s3.6-1.6,3.6-3.6V44.8c0-2-1.6-3.6-3.6-3.6h-6.1l37.9-33l38,33h-6.1c-2,0-3.6,1.6-3.6,3.6v209.5 c0,2,1.6,3.6,3.6,3.6s3.6-1.6,3.6-3.6V48.4h12.1c1.5,0,2.8-0.9,3.3-2.3C251.2,44.7,250.8,43.1,249.7,42.1z" />
        <path d="M187.9,134.4H15.5c-8.5,0-15.5,7-15.5,15.5v92.4c0,8.5,7,15.5,15.5,15.5h172.4c8.5,0,15.5-7,15.5-15.5v-92.4 C203.4,141.3,196.4,134.4,187.9,134.4z M7.1,174.5c17.4-1.7,31.2-15.6,32.9-32.9h147.9c4.6,0,8.4,3.8,8.4,8.4v67.9 c-17.4,1.7-31.3,15.6-32.9,32.9H15.5c-4.6,0-8.4-3.8-8.4-8.4V174.5z M7.1,167.3v-17.4c0-4.6,3.8-8.4,8.4-8.4h17.4 C31.3,155,20.6,165.7,7.1,167.3z M196.3,225v17.4c0,4.6-3.8,8.4-8.4,8.4h-17.4C172.1,237.3,182.8,226.6,196.3,225z" />
        <path d="M101.7,234.8c21.3,0,38.7-17.4,38.7-38.7s-17.4-38.7-38.7-38.7S63,174.8,63,196.1S80.4,234.8,101.7,234.8z M70.1,196.1 c0-17.4,14.2-31.6,31.6-31.6s31.6,14.2,31.6,31.6s-14.2,31.6-31.6,31.6S70.1,213.5,70.1,196.1z" />
      </g>
    </svg>
  )
}
export default SvgGleichberechtigungVerdienstabstand227212823129
